import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { NotifierService } from '@app/shared/services/notifier.service';
import { TaskService } from '@app/shared/task/shared/task.service';
import { HelperFlowService } from '@app/shared/services/helper-flow.service';
import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  ComponentFactoryResolver,
  AfterContentChecked,
} from "@angular/core";
import { isEmpty, find, filter } from "lodash";
import { DragulaService } from "ng2-dragula";
import { PaginationInstance } from "ngx-pagination";
import { Subscription } from "rxjs/Subscription";
import { ToastrService } from "ngx-toastr";
import { LocalDataSource } from "ng2-smart-table";
import {
  Actividad,
  ActividadCalendario,
  Categoria,
  Const,
  Microproceso,
  Proceso,
  Tarea,
  Tramite,
  TramiteDefaultCorto,
  HistorialMicroproceso,
  TramiteEstado,
  ConsultaTramite,
  Filtro,
  BaseControl,
  ParametroFiltro,
  EstructuraEspecifica,
  ValoresEspecificos,
  Option,
  DataIniciarSecundaria,
  TypeProcess,
  ConfirmComponent,
  TareaFinalizacion,
  ContextAutoSave,
  TaskEvent,
  ConfigFinishDefault,
  Static,
  Etapas
} from '@app/shared';
import { GlobalNotifierService, Logger, AuthenticationService } from '@app/core';
import { SessionStorage } from 'ngx-webstorage';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { DynamicContentFormComponent } from '@app/components/dynamic-content-form/dynamic-content-form.component';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';
import { FiltrosSelector, FlowConfig, FlowFormService, FlowService } from './shared';
import { FlowTitle } from '@app/shared/title';
import { Subject } from 'rxjs';
import { environment } from "@env/environment";
import { SelectProcessComponent } from "./select-process/select-process.component";
import { config } from "process";
import { Annulation } from '@app/shared/models/anulacion.model';
import { Console } from "console";
import { DatePipe } from "@angular/common";
import { SessionStorageManagement } from "@app/shared/Library/session-storage-management";

const log = new Logger("FlowComponent");

type Template = "primary" | "instances" | "filtersTpl";
export class History {
  active = false;
  categories: Categoria[];
  processes: Proceso[];
  tramites: TramiteDefaultCorto[];
  category: Categoria;
  process: Proceso;
  tramite: TramiteDefaultCorto;
}

interface DataSourceTramite {
  id: number;
  fechaCreacion: Date;
  idExpediente: number;
  radicadoExpediente: string;
  estadoNombre: string;
  estado: TramiteEstado;
  radicadoSolicitud: string;
}

export interface DataService{
  tipo: string;
  valores: any[];
}

@Component({
  selector: "iw-flow",
  templateUrl: "./flow.component.html",
  styleUrls: ["./flow.component.scss"],
  providers: [FlowService, HelperFlowService, FlowFormService, TaskService, DatePipe, SessionStorageManagement],
})
export class FlowComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked  {
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  @SessionStorage() isDesignTask: string;
  // Define el mensaje de la alerta de carga dinamica
  messageAlertDynamic = "";
  // Contiene el tipo de proceso que se esta renderizando
  typeProcess: TypeProcess = "process";
  // id secondary
  idTaskSecondary = -1;
  // id secondary
  idSecondary = -1;
  // Activa el modulo de carga de datos
  activateDataLoad = false;
  // Variable que determina si el formualrio está abierto
  openForm: Boolean = false;
  // Historial de las decisiones del usuario en los filtros de las tablas default
  history: History = new History();
  //trámite
  procedureName: any = {};
  // Todos las instancias de un trámite(default)
  instances: ConsultaTramite[];
  // Instancia del trámite(default) seleccionado
  // La instancia puede ser un microproceso
  instance: Tramite | Microproceso;
  data: FlowTitle;
  // Define si el botón de documentos del expediente es visible o no
  buscador_documentos: boolean = false;
  // Define si el botón de subir documentos es visible o no
  subir_anexos_documentos: boolean = false;
  _subir_anexos_documentos: boolean = false;
  // Define si el botón de seguimientos del expediente es visible o no
  buscador_seguimiento: boolean = false;
  // Define si el botón de anular trámite es visible o no
  annulation: boolean = false;
  // Define si el tramite es una liquidacion
  liquidation: boolean = false;
  // Define si posee la configuracion para eliminar un tramite de liquidacion
  remove_liquidation: boolean = false;
  // Contiene la información de anulación
  annulationInfo: Annulation = {};
  // Contiene los campos de filtros de la consulta del tramite seleccionado
  filters: Filtro;
  // Suscripción a las notificaciones de los componentes hijos
  notifications: Subscription;
  // Configuración del paginador de las instancias
  pagination = Const.PAGINATION;
  configPagInstances: PaginationInstance = {
    id: "instances",
    itemsPerPage: Const.PAGINATION.itemsPerPage,
    currentPage: 1,
  };
  // Contiene la data a mostrar en la tabla e busqueda
  source: DataSourceTramite[] = [];
  // Contiene los controles de el formulario de filtros de la consulta
  controls: BaseControl<any>[] = [];
  // Contiene los controles de el formulario de cancelación de una secundaria
  controlsCancelSecondary: BaseControl<any>[] = [];
  // Datos para llenar la tabla deconsulta de instancias
  sourceData: LocalDataSource;
  // Configuración de la tabla
  settings = {};
  // Contiene los templates de los controles personalizados
  templates = {};
  // fecha máxima para el selector de rango
  maxDate = new Date();
  //modelo del selector de fecha máxima
  toDateSelector = '';
   // fecha máxima para el selector de fecha desde
  maxDateMin = new Date();
   //modelo del selector de fecha máxima
  fromDateSelector = '';
  //Modelo para el rango de fechas seleccionado 
  selectedRange = ''
  // Contiene el formulario de filtros
  filterForm: FormGroup;
  // Estados del tramite
  readonly tramiteState = Const.STATUS_TRAMITE;
  // Determina si se esta ejecutando una petición al backend
  isLoading = {
    listInstances: false,
    createInstance: false,
    showInstance: false,
    finishTask: false,
    startSecondary: false,
    cancelSecondary: false,
    associationTramite: false,
    alertDynamic: false,
  };
  // Muestra diferentes elementos
  show = {
    // Significado de la iconografía del flujo
    helperFlow: false,
    // Formulario de filtros de consulta
    filterForm: false,
  };
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  isDesign = "compact";
  // Determina cuando la consulta se realizo por un filtro o sin filtro
  shearchFilter = false;
  historysMicroproces = {};
  historyMicroproce: HistorialMicroproceso[];
  idHistorySelect = 0;
  // Contiene el id de la primera actividad activada
  idActivityFirstActive = -1;
  // Contexto de las tareas para el auto guardado
  contextAutoSave: ContextAutoSave[] = [];
  // Contiene las etapas del tramite ( etapa actual y general)
  stage: Etapas;
  //Contiene la lista de parámetros para filtar por
  parameterList: FiltrosSelector = {};
  // columnsSelect: any[] = [];
  // dataTableModal: any[] = [];
  // form: FormGroup = new FormGroup({
  //   exampleModalSelect: new FormControl()
  // });
  columnsSelect: any = {};
  dataTableModal: any = {};
  form: any = {};
  // Lista de parámetros que no han sido seleccionados para llena los selectores
  unselectedParameters: any[] = []
  // Estructura oculta de la tabla
  structureProcess: any[] = []
  // Lista de parámetros que nunca cambia
  noChangeParameters: any[] = []
  //formulario reactivo para agregar filtros
  formulario: FormGroup;
  // controla si mostrar o no el mensaje deParámetros de búsqueda
  searchFilters: boolean = false;
  // Modelo para guardar la selección de los filtros
  selectedParameter: any[] = [];
  // habilita la tabla de procesos
  enableTable = false;
  // define si se realiza la búsqueda por proceso
  searchByProcess: boolean = environment.searchByProcess;
  // muestra el modal de confirmacion para inicio de tramites
  confirmStartProcedure: boolean = environment['requestConfirmationStartProcedure']? environment['requestConfirmationStartProcedure'] : false;
  // lista de opciones para el filtro de tipo en_lista
  select_list: any[] = [];
  // modelo para la selección del filtro de tipo en_lista
  selectedListItem: any = null;
  // controla que cuando la tabla tiene documento y se dé click en descargar, no se pase al trámite directamente
  downloadingDocument: boolean = false;
  // controla que cuando la tabla tiene documento y se dé click en previsualizar, no se pase al trámite directamente
  previewDocument: boolean = false;
  //variables para timer// eliminar después
  interval: any;
  timeLeft: number = 3;
  // ids del proceso y del trámite
  process_id: any;
  procedure_id: any;
  // propiedades o configuración de color para los rows de la tabla
  colorConfiguration: any = {};
  // color
  color: any = "blue"
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Plantilas disponibles para mostrar en el componente
  @ViewChild("primaryTpl") primaryTpl: TemplateRef<any>;
  @ViewChild("instancesTpl") instancesTpl: TemplateRef<any>;
  @ViewChild("filtersTpl") filtersTpl: TemplateRef<any>;
  // Referencia de el selector personalizado para los formularios
  @ViewChild("ngSelectFilter") ngSelectTpl: TemplateRef<any>;
  // Referencia del modal de cancelacion de secundarias
  @ViewChild("modalCancelSecondary") modalCancelSecondary: TemplateRef<any>;
  // Componente select-tramite
  @ViewChild(SelectTramiteComponent) stcRef: SelectTramiteComponent;
  // Componente select-process
  @ViewChild(SelectProcessComponent) stcRefProcess: SelectProcessComponent;
  // Componente de confirmaciones
  @ViewChild(ConfirmComponent) confirmRef: ConfirmComponent;
  // Contenedor del formulario dinamico para auto guardado
  @ViewChild("componentFormAutoSave", { read: ViewContainerRef }) componentFormAutoSave: ViewContainerRef;
  // Referencia al template de la modal de visualizacion de documento
  @ViewChild('templatePreviewDoc') private templatePreviewDoc: TemplateRef<any>;
  // Referencia a el componente de renderizacion de formulario de tareas
  private componentRef: ComponentRef<DynamicContentFormComponent>;
  // Actividades de la instancia
  private _activities: Actividad[];
  // Plantilla que muestra el contenido del componente
  private _template: TemplateRef<any>;
  // Plantilla que muestra el contenido del componente
  private _templateF: TemplateRef<any>;
  // Controla si se muestra las tareas asociadas
  private destroy: Subject<void> = new Subject<void>();

  resApi: any;
  idsSelected: any[] = [];

  constructor(
    private cdRef: ChangeDetectorRef,
    private fs: FlowService,
    private ns: NotifierService,
    private gns: GlobalNotifierService,
    public hfs: HelperFlowService,
    private ds: DragulaService,
    private toastr: ToastrService,
    private ffs: FlowFormService,
    private modalService: BsModalService,
    private cfr: ComponentFactoryResolver,
    private ts: TaskService,
    private as: AuthenticationService,
    private sts: ScrollToService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private sst: SessionStorageManagement,
  ) {}

  ngOnInit() {
    let validSession = this.sst.validSessionStorage();
    if(validSession){
      let actualTaskSize = this.isDesignTask;
      this.sst.deletePersistentData();
      this.isDesignTask = actualTaskSize;
    }
    this.form = {};
    this.dataTableModal = {};
    this.columnsSelect = {};
    this.isDesign = this.isDesignTask ? this.isDesignTask : "compact";
    this.activateDataLoad = this.as.confirmPermission(
      Const.types_permissions.instanceProcess,
      Const.types_action_permissions.dataLoad
    );
    this._subir_anexos_documentos = this.as.confirmPermission(
      Const.types_permissions.instanceProcess,
      Const.types_action_permissions.uploadDocument
    );
    
    this.templates["ngSelectTpl"] = this.ngSelectTpl;
    this.controlsCancelSecondary = this.ffs.getControlsCancelSecondary();
    // Escuchar todas las notificaciones de los elementos hijos del flujo
    this.notifications = this.ns.get().subscribe((n) => {
      // Si se ejecutó el evento click en una tarea
      if (n.source === "task" && n.eventTriggered === "click") {
        this.clickedTask(n.data, n.action);
      } else if (n.source === "title" && n.eventTriggered === "change" && n.action === "changeDesign") {
        this.isDesign = this.isDesignTask ? this.isDesignTask : "compact";
      }
    });

    // Si las bolsas ya existen se eliminan previamente antes de volver a crearlas
    if (this.ds.find("bag-activities")) {
      this.ds.destroy("bag-activities");
    }
    if (this.ds.find("bag-tasks")) {
      this.ds.destroy("bag-tasks");
    }

    // Configuraciones para la bolsa de actividades (dragula)
    this.ds.setOptions("bag-activities", {
      moves: (el: any, container: any, handle: any) => {
        return false;
      },
    });
    // Configuraciones para la bolsa de tareas (dragula)
    this.ds.setOptions("bag-tasks", {
      moves: (el: any, container: any, handle: any) => {
        return false;
      },
    });
    // Se inicia la configuracion de la tabla
    const configTable = new FlowConfig();
    configTable.accion.subscribe((res: any) => {
      switch (res.action) {
        case "descargar":
          this.downloadingDocument = true;
          let id_doc = res.id_documento ? res.id_documento : (res.data && res.data.id_documento) ? res.data.id_documento : null;
          this.download(res.type_document, id_doc)
          break;
        case "preview_documento":
            this.previewDocument = true;
            let id_doc_preview = res.id_documento_preview ? res.id_documento_preview : (res.data && res.data.id_documento_preview) ? res.data.id_documento_preview : null;
            this.preview(id_doc_preview)
            break;
        case "ver_flujo":
          this.getInstance(res.data.id);
          break;
        default:
          break;
      }
    });
    //Limpiar array de ids seleccionados
    this.idsSelected = [];
  }

  ngAfterContentChecked() : void {
    this.cdRef.detectChanges();
  }

  ngAfterViewInit() {
    this.template = "primary";
    this.history.active = true;
    // Vigilar los cambios que se producen en los selects de categoria, proceso y tramite.
    if(this.searchByProcess){
      this.stcRefProcess.dataObserver.subscribe((change) => {
        if (change.target === "category") {
          this.history.category = change.data as Categoria;
          this.instances = [];
          this.source = [];
          this.sourceData = null;
        }
        if (change.target === "process") {
          this.history.process = change.data as Proceso;
        }
        if (change.target === "tramite") {
          this.history.tramite = change.data as TramiteDefaultCorto;
          if(change.data && change.data['carga'] == true){
              this.activateDataLoad = true;
          }else{
            this.activateDataLoad = false;
          }
        }
      });
    }else{
      this.stcRef.dataObserver.subscribe((change) => {
        if (change.target === "category") {
          this.history.category = change.data as Categoria;
          this.instances = [];
          this.source = [];
          this.sourceData = null;
        }
        if (change.target === "process") {
          this.history.process = change.data as Proceso;
        }
        if (change.target === "tramite") {
          this.history.tramite = change.data as TramiteDefaultCorto;
          if(change.data && change.data['carga'] == true){
            this.activateDataLoad = true;
          }else{
            this.activateDataLoad = false;
          }
        }
      });
    }

    // Tratar las notificaciones globales en espera para este componente
    const globalNotifications = this.gns.get({
      destiny: "FlowComponent",
    });
    globalNotifications.forEach(async (item, i) => {
      if (item.action === "showFlow") {
        const data: ActividadCalendario = item.data;
        let idFlow = null;
        if (data.microproceso) {
          idFlow = data.microproceso;
        } else if (data.secundaria) {
          idFlow = data.secundaria;
          this.idSecondary = data.secundaria;
          this.typeProcess = "secondary_process";
        } else {
          idFlow = data.id_tramite;
        }
        // Setear los selects de categoría, proceso y tramite
        if(this.searchByProcess){
          await this.stcRefProcess.reload("category", data.categoria);
          await this.stcRefProcess.reload("process", data.proceso);
          await this.stcRefProcess.reload("tramite", data.tramite);
        }else{
          await this.stcRef.reload("category", data.categoria);
          await this.stcRef.reload("process", data.proceso);
          await this.stcRef.reload("tramite", data.nombre_tramite);
        }
        // Validar si el flujo no es un microproceso y mostrar flujo
        if (!data.microproceso && !data.secundaria) {
          this.getInstance(idFlow);
        } else {
          this.hfs.updateFlowHistory(data.id_tramite, false, false);
          this.runMicroProcess(idFlow);
        }
        // Eliminar este mensaje
        this.gns.delete(item.index);
        log.debug(`Consultando flujo ${idFlow} remitido desde el calendario de actividades.`);
      }
    });
  }
  cleanFlow(){
    this.instance = null
  }
  ngOnDestroy() {
    // Eliminar suscripción a las notificaciones
    this.notifications.unsubscribe();
    this.destroy.next();
    this.destroy.complete();
    this.form = {};
    this.dataTableModal = {};
    this.columnsSelect = {};
    let validSession = this.sst.validSessionStorage();
    if(validSession){
      let actualTaskSize = this.isDesignTask;
      this.sst.deletePersistentData();
      this.isDesignTask = actualTaskSize;
    }
  }

  set activities(v: Actividad[]) {
    this._activities = this.hfs.refineActivities(v, {
      filterByStatus: "inactive",
    });
  }
  get activities(): Actividad[] {
    return this._activities;
  }

  /**
   * Define la plantilla que se debe mostrar.
   *
   * @memberof FlowComponent
   */
  set template(tpl: Template | TemplateRef<any>) {
    let template: TemplateRef<any>;
    if (!(tpl instanceof TemplateRef)) {
      switch (tpl) {
        case "instances":
          template = this.instancesTpl;
          break;
        case "filtersTpl":
          template = this.filtersTpl;
          break;
        default:
          template = this.primaryTpl;
          break;
      }
    } else {
      template = tpl;
    }
    this._template = template;
    this.cdRef.detectChanges();
  }

  get template() {
    return this._template;
  }

  set templateF(tpl: TemplateRef<any>) {
    // let template: TemplateRef<any>;
    // template = tpl;
    this._templateF = tpl;
    this.cdRef.detectChanges();
  }

  get templateF() {
    return this._templateF;
  }

  /**
   * Evento que se ejecuta al seleccionar un trámite por default.
   * - Consulta las instancias del trámite por default.
   *
   * @memberof FlowComponent
   */
  async selectedDefaultTramite() {
    if(this.searchByProcess){
      let change_search = false;
      if(this.process_id && this.process_id != this.stcRefProcess.process.id){
        change_search = true;
      }
      if((this.procedure_id && this.stcRefProcess.tramite && this.procedure_id != this.stcRefProcess.tramite.id) || (this.procedure_id && !this.stcRefProcess.tramite)){
        change_search = true;
      } 
      this.isLoading.listInstances = true;
      this.settings = {};
      // let voidData: any[] = [];
      // this.sourceData = new LocalDataSource(voidData);
      this.process_id = this.stcRefProcess.process.id;
      this.procedure_id = null;
      if(this.stcRefProcess.tramite){
        this.procedure_id = this.stcRefProcess.tramite.id;
      }
      this.template = "filtersTpl";
      if(this.procedure_id !== null){
        this.fs.getParameters(this.process_id, this.procedure_id).subscribe(async res=>{
          if(res && res[0].id){
            this.resApi = res[0];
            this.parameterList = await res[0];
            this.structureProcess = Static.copyObjet(this.parameterList.estructura);
            this.structureProcess.forEach(sp=>{
              if(sp.propiedades && sp.propiedades !== null && sp.propiedades.tipo == 'determinar_color'){
                this.colorConfiguration = sp.propiedades;
              }
            })
            if(this.parameterList.filtros && this.parameterList.filtros.length){
              this.unselectedParameters = Static.copyObjet(this.parameterList.filtros);
            }else{
              this.unselectedParameters = []
              this.isLoading.listInstances = true;
              // this.structureProcess.sort(function (a, b) {
              //   if (a.orden > b.orden) {
              //     return 1;
              //   }
              //   if (a.orden < b.orden) {
              //     return -1;
              //   }
              //   return 0;
              // });
              // const configTable = new FlowConfig(this.structureProcess);
              // this.settings = configTable.settingsProcess;
              this.show.filterForm = true;
              this.enableTable = true;
            }
            this.structureProcess.sort(function (a, b) {
              if (a.orden > b.orden) {
                return 1;
              }
              if (a.orden < b.orden) {
                return -1;
              }
              return 0;
            });
            const configTable = new FlowConfig(this.structureProcess, this.parameterList);
            this.idsSelected = [];
            configTable.accion.subscribe((res: any) => {
              switch (res.action) {
                case "descargar":
                  this.downloadingDocument = true;
                  let id_doc = res.id_documento ? res.id_documento : (res.data && res.data.id_documento) ? res.data.id_documento : null;
                  this.download(res.type_document, id_doc)
                  break;
                case "preview_documento":
                    this.previewDocument = true;
                    let id_doc_preview = res.id_documento_preview ? res.id_documento_preview : (res.data && res.data.id_documento_preview) ? res.data.id_documento_preview : null;
                    this.preview(id_doc_preview)
                    break;
                case "ver_flujo":
                  this.getInstance(res.data.id);
                  break;
                default:
                  break;
              }
            });
            this.settings = configTable.settingsProcess;
            this.unselectedParameters.forEach(item=>{
              item['disponible'] = true;
            })
            this.noChangeParameters = Static.copyObjet(this.parameterList.filtros);
            this.noChangeParameters.forEach(item=>{
              item['disponible'] = true;
            })
          }
          if(this.parameterList.filtros && this.parameterList.filtros.length == 0){
            if(this.procedure_id !== null){
              this.fs.getDynamicProcedureData(this.process_id, this.procedure_id).subscribe(res=>{
                if(res && res.length){
                  this.sourceData = new LocalDataSource(res);
                  this.isLoading.listInstances = false;
                }else{
                  this.isLoading.listInstances = false;
                }
              })
            }else{
              this.fs.getDynamicProcedureData(this.process_id).subscribe(res=>{
                if(res && res.length){
                  this.sourceData = new LocalDataSource(res);
                  this.isLoading.listInstances = false;
                }else{
                  this.isLoading.listInstances = false;
                }
              })
            }
          }else{
            if(change_search){
              this.sourceData = new LocalDataSource([]);
              this.sourceData.refresh();
              this.enableTable = false;
              this.filterForm = null;
              this.controls = [];
              this.instances = [];
              this.formulario = this.fb.group({
                filtros: this.fb.array([]),
              });
              this.selectedParameter.length = 0;
              this.fromDateSelector = "";
              this.toDateSelector = "";
              this.selectedListItem = null;
              this.show.filterForm = true;
            }
            this.isLoading.listInstances = false;
            
          }
          
          this.template = "filtersTpl";
        }, err=>{
          this.isLoading.listInstances = false;
        })
      }else{
        this.fs.getParameters(this.process_id).subscribe(async res=>{
          if(res && res[0].id){
            this.parameterList = await res[0];
            this.structureProcess = Static.copyObjet(this.parameterList.estructura);
            this.structureProcess.forEach(sp=>{
              if(sp.propiedades && sp.propiedades !== null && sp.propiedades.tipo == 'determinar_color'){
                this.colorConfiguration = sp.propiedades;
              }
            })
            if(this.parameterList.filtros && this.parameterList.filtros.length){
              this.unselectedParameters = Static.copyObjet(this.parameterList.filtros);
            }else{
              this.unselectedParameters = []
              this.isLoading.listInstances = true;
              // this.structureProcess.sort(function (a, b) {
              //   if (a.orden > b.orden) {
              //     return 1;
              //   }
              //   if (a.orden < b.orden) {
              //     return -1;
              //   }
              //   return 0;
              // });
              // const configTable = new FlowConfig(this.structureProcess);
              // this.settings = configTable.settingsProcess;
              this.show.filterForm = true;
              this.enableTable = true;
            }
            this.structureProcess.sort(function (a, b) {
              if (a.orden > b.orden) {
                return 1;
              }
              if (a.orden < b.orden) {
                return -1;
              }
              return 0;
            });
            const configTable = new FlowConfig(this.structureProcess);
            configTable.accion.subscribe((res: any) => {
              switch (res.action) {
                case "descargar":
                  this.downloadingDocument = true;
                  let id_doc = res.id_documento ? res.id_documento : (res.data && res.data.id_documento) ? res.data.id_documento : null;
                  this.download(res.type_document, id_doc)
                  break;
                case "preview_documento":
                    this.previewDocument = true;
                    let id_doc_preview = res.id_documento_preview ? res.id_documento_preview : (res.data && res.data.id_documento_preview) ? res.data.id_documento_preview : null;
                    this.preview(id_doc_preview)
                    break;
                default:
                  break;
              }
            });
            this.settings = configTable.settingsProcess;
            this.unselectedParameters.forEach(item=>{
              item['disponible'] = true;
            })
            this.noChangeParameters = Static.copyObjet(this.parameterList.filtros);
            this.noChangeParameters.forEach(item=>{
              item['disponible'] = true;
            })
          }
          if(this.parameterList.filtros && this.parameterList.filtros.length == 0){
            if(this.procedure_id !== null){
              await this.fs.getDynamicProcedureData(this.process_id, this.procedure_id).subscribe(res=>{
                if(res && res.length){
                  this.sourceData = new LocalDataSource(res);
                  this.isLoading.listInstances = false;
                }
              })
            }else{
              await this.fs.getDynamicProcedureData(this.process_id).subscribe(async res=>{
                if(await res && res.length){
                  this.isLoading.listInstances = true;
                  if(this.colorConfiguration && this.colorConfiguration.tipo){
                    await res.forEach((r, i)=>{
                      if(r && r.color){
                        let config = {};
                        config['color'] = {};
                        config['color']['rango'] = this.colorConfiguration.rango_colores;
                        config['color']['valor'] = r.color;
                        config['color']['indice'] = i;
                        config['color']['datos'] = r;
                        // r['color']['rango'] = r.color;
                        r['color'] = config;
                      }
                    })
                  }
                  this.sourceData = new LocalDataSource(res);
                  this.color = "black";
                  this.isLoading.listInstances = false;
                }else{
                  this.sourceData = new LocalDataSource(res);
                  this.isLoading.listInstances = false;
                }
              })
            }
          }else{
            if(change_search){
              this.sourceData = new LocalDataSource([]);
              this.sourceData.refresh();
              this.enableTable = false;
              this.filterForm = null;
              this.controls = [];
              this.instances = [];
              this.formulario = this.fb.group({
                filtros: this.fb.array([]),
              });
              this.selectedParameter.length = 0;
              this.fromDateSelector = "";
              this.toDateSelector = "";
              this.selectedListItem = null;
              this.show.filterForm = true;
            }
            this.isLoading.listInstances = false;
          }
          this.template = "filtersTpl";
          
        }, err=>{
          this.isLoading.listInstances = false;
        })
      }
    }else{
      if (this.history.tramite && this.history.tramite.id) {
      this.isLoading.listInstances = true;
      this.instances = [];
      this.controls = [];
      this.filters = await this.fs.getFiltersShearchTramite(this.history.tramite.id);
      if (!this.filters || !this.filters.parametros || !this.filters.parametros.length) {
        this.shearchTramites(this.history.tramite.id);
      } else {

        if (this.filters.parametros.length) {
          await this.asyncForEach(this.filters.parametros, async (parameter: ParametroFiltro) => {
            if (parameter.campo['maestra'] && parameter.tipo_campo.nombre === 'ngSelect') {
              await this.loadingSelectsOptions(parameter);
            }
          });
        }
        this.controls = this.ffs.getFieldsFilterReportStructure(this.filters.parametros, this.templates);
        this.isLoading.listInstances = false;
        this.show.filterForm = true;
      }
      // this.backupDataSelectTramiteComponent();
      this.template = 'instances';
      } else {
        this.toastr.warning('Seleccione un tramite.', 'Información incompleta');
      }
    }
    
  }

  /**
   * Guardar copia de los datos de SelectTramiteComponent
   *
   * @memberof FlowComponent
   */
  backupDataSelectTramiteComponent() {
    if(this.searchByProcess){
      const backup = this.stcRefProcess.getAll();
      for (const key in backup) {
        if (backup.hasOwnProperty(key)) {
          this.history[key] = backup[key];
        }
      }
    }else{
      const backup = this.stcRef.getAll();
      for (const key in backup) {
        if (backup.hasOwnProperty(key)) {
          this.history[key] = backup[key];
        }
      }
    }
  }

  /**
   * Evento que se ejecuta al seleccionar una instancia
   * del trámite por default.
   * - Setea la instancia global usada para generar el flujo.
   * - Setea las actividades del flujo.
   *
   * @param {(Tramite | Microproceso)} instance
   * @param {boolean} [goBack=false]
   * @param {boolean} [clean=false]
   * @param {boolean} [changeCurrent=false]
   * @memberof FlowComponent
   */
  selectedInstance(
    instance: Tramite | Microproceso,
    goBack: boolean = false,
    clean: boolean = false,
    changeCurrent: boolean = false
  ) {
    this.hfs.updateFlowHistory(instance, goBack, clean, changeCurrent);
    this.instance = instance;
    if (instance && instance.actividades && instance.actividades.length) {
      for (const activity of instance.actividades) {
        if (activity.actividad_estado && activity.actividad_estado.nombre === Const.STATUS_ACTIVITY.pending) {
          this.idActivityFirstActive = activity.id;
          break;
        }
      }
    }
    this.activities = instance.actividades;
    this.buscador_documentos = instance.buscador_documentos;
    if (this._subir_anexos_documentos) {
      this.subir_anexos_documentos = instance.subir_anexos;
    }
    this.buscador_seguimiento = instance.buscador_seguimiento;
    this.annulation = instance.anulacion;
    this.liquidation = instance.liquidacion;
    this.remove_liquidation = instance.eliminar_liquidacion;
    if(this.annulation){
      this.annulationInfo = {};
      this.fs.getAnnulationInfo(instance.id).subscribe(res=>{
        if(res){
          this.annulationInfo = res
        }
      })
    }
    this.data = this.hfs.getFlowTitle(instance);
    this.stage = null;
    this.fs.getStages(this.data.idTramite).subscribe((stage) => {
      if (Object.entries(stage.etapa_actual).length > 0) {
        this.stage = stage;
      }
    });
  }

  /**
   * Retrocede un nivel en el flujo.
   *
   * @memberof FlowComponent
   */
  goBack() {
    if (this.idSecondary > 0) {
      if (this.idSecondary === this.instance.id) {
        this.typeProcess = "process";
        this.idSecondary = -1;
        this.idTaskSecondary = -1;
      }
    }
    this.hfs.returnToPreviousFlow(
      // Generar el flujo de la instancia del trámite
      (idTramite) => {
        this.isLoading.showInstance = true;
        this.fs
          .getInstance(idTramite)
          .finally(() => {
            this.isLoading.showInstance = false;
          })
          .subscribe((instance: Tramite) => {
            this.selectedInstance(instance, true);
            this.typeProcess = "process";
            this.idSecondary = -1;
            this.idTaskSecondary = -1;
          });
      },
      // Generar el flujo con el microproceso
      (idMicroProcess) => this.runMicroProcess(idMicroProcess, true)
    );
    //Limpiar array de ids seleccionados
    this.idsSelected = [];
  }

  openConfirmInitInstance(dataLoad:boolean = false){
    if(this.confirmStartProcedure){
      let procedure = null;
      if(this.searchByProcess && this.stcRefProcess.tramite){
        procedure = this.stcRefProcess.tramite
      }
      else if(!this.searchByProcess && this.stcRef.tramite){
        procedure = this.stcRef.tramite
      }
      else{
        this.toastr.warning("Seleccione un tramite.", "Información incompleta");
      }
      this.confirmRef
        .new({
          question: "¿Esta seguro que desea iniciar el procedimiento: "+procedure.nombre+"?",
          labelConfirm: "Sí",
          labelDecline: "No",
        })
        .then(async (res) => {
          if (res) {
            this.newInstance(dataLoad);
          }
        });
    }else{
      this.newInstance(dataLoad);
    }
    
  }

  /**
   * Crea una nueva instancia utilizando como base
   * un trámite por default.
   *
   * @param {boolean} [dataLoad=false]
   * @memberof FlowComponent
   */
  newInstance(dataLoad: boolean = false) {
    if(this.searchByProcess){
      if (this.stcRefProcess.tramite && this.stcRefProcess.tramite.id) {
        this.isLoading.createInstance = true;
        this.fs
          .newInstance(this.stcRefProcess.tramite.id, dataLoad)
          .finally(() => (this.isLoading.createInstance = false))
          .subscribe(
            (idInstance) => {
              // Generar el flujo del la intancia del trámite
              this.getInstance(idInstance.id_tramite);
              log.debug("Create new instance: ", idInstance.id_tramite);
            },
            (err) => {
              this.isLoading.createInstance = false;
              log.debug("Create error new instance: ", err);
            }
          );
      } else {
        this.toastr.warning("Seleccione un tramite.", "Información incompleta");
      }
    }else{
      if (this.stcRef.tramite && this.stcRef.tramite.id) {
        this.isLoading.createInstance = true;
        this.fs
          .newInstance(this.stcRef.tramite.id, dataLoad)
          .finally(() => (this.isLoading.createInstance = false))
          .subscribe(
            (idInstance) => {
              // Generar el flujo del la intancia del trámite
              this.getInstance(idInstance.id_tramite);
              log.debug("Create new instance: ", idInstance.id_tramite);
            },
            (err) => {
              this.isLoading.createInstance = false;
              log.debug("Create error new instance: ", err);
            }
          );
      } else {
        this.toastr.warning("Seleccione un tramite.", "Información incompleta");
      }
    }
  }

  /**
   * Consulta una instancia de un trámite y genera su flujo.
   *
   * @param {number} idInstance
   * @memberof FlowComponent
   */
  getInstance(idInstance: number, clean: boolean = true) {
    if(!this.downloadingDocument && !this.previewDocument){
      this.isLoading.showInstance = true;
      this.fs
        .getInstance(idInstance)
        .finally(() => {
          this.isLoading.showInstance = false;
        })
        .subscribe(async (instance: Tramite) => {
          this.selectedInstance(instance, false, clean);
          if(this.searchByProcess){
            await this.stcRefProcess.reload("tramite", instance.nombre);
          }else{
            await this.stcRef.reload("tramite", instance.nombre);
          }
        });
      this.template = "primary";
    }
    //Limpiar array de ids seleccionados
    this.idsSelected = [];
  }

  /**
   * Controla el cambio de el select de versiones de microproceso
   *
   * @param {*} data
   * @memberof FlowComponent
   */
  changeSelectMicro(data: HistorialMicroproceso) {
    if (data) {
      this.runMicroProcess(Number(data.id), false, false, true);
    }
  }

  /**
   * Define si el proceso seleccionado esta finalizado
   *
   * @returns {boolean}
   * @memberof FlowComponent
   */
  selectProcessFinish(): boolean {
    let valid = false;
    if (this.idHistorySelect) {
      const item = find(this.historyMicroproce, { id: this.idHistorySelect });
      if (item) {
        valid = item.finalizado;
      }
    }
    return valid;
  }

  /**
   * Refresca el flujo actual
   *
   * @memberof FlowComponent
   */
  refreshFlow() {
    if (this.hfs.flowsHistory.length === 1) {
      this.isLoading.showInstance = true;
      this.fs
        .getInstance(this.hfs.flowsHistory[0])
        .finally(() => {
          this.isLoading.showInstance = false;
        })
        .subscribe((instance: Tramite) => {
          this.selectedInstance(instance, false, false, true);
        });
    } else {
      this.runMicroProcess(this.hfs.flowsHistory[this.hfs.flowsHistory.length - 1], false, false, true);
    }
  }

  /**
   * Setea en una variable el formulario creado para los filtros
   *
   * @param {FormGroup} form
   * @memberof FlowComponent
   */
  setForm(form: FormGroup) {
    this.filterForm = form;
  }

  /**
   * Controla la accion a realizar despues de la interacion del usuario en el formulario
   *
   * @param {boolean} filters
   * @memberof FlowComponent
   */
  searchTramiteFilter(filters: boolean) {
    this.isLoading.listInstances = true;
    this.instances = [];
    if (filters) {
      if (this.filterForm.valid) {
        this.shearchTramites(this.history.tramite.id, this.filterForm.value);
      }
    } else {
      this.shearchTramites(this.history.tramite.id);
    }
  }

  /**
   * Accion de retroceder en la vista
   *
   * @memberof FlowComponent
   */
  async backInShearchTramite() {
    //Limpiar array de ids seleccionados
    this.idsSelected = [];
    if (this.controls.length && !this.show.filterForm) {
      this.show.filterForm = true;
    } else {
      this.searchFilters = false;
      this.filterForm = null;
      this.controls = [];
      this.instances = [];
      this.formulario = this.fb.group({
        filtros: this.fb.array([]),
      });
      this.selectedParameter.length = 0;
      this.fromDateSelector = "";
      this.toDateSelector = "";
      this.selectedListItem = null;
      if(this.enableTable && this.parameterList.filtros.length){
        this.enableTable = false;
        if(this.procedure_id){
          this.fs.getParameters(this.process_id, this.procedure_id).subscribe(async res=>{
            this.parameterList = await res[0];
            this.unselectedParameters = Static.copyObjet(this.parameterList.filtros);
            this.structureProcess = Static.copyObjet(this.parameterList.estructura);
            this.unselectedParameters.forEach(item=>{
              item['disponible'] = true;
            })
            this.noChangeParameters = Static.copyObjet(this.parameterList.filtros);
            this.noChangeParameters.forEach(item=>{
              item['disponible'] = true;
            })
          })
        }else{
          this.fs.getParameters(this.process_id).subscribe(async res=>{
            this.parameterList = await res[0];
            this.unselectedParameters = Static.copyObjet(this.parameterList.filtros);
            this.structureProcess = Static.copyObjet(this.parameterList.estructura);
            this.unselectedParameters.forEach(item=>{
              item['disponible'] = true;
            })
            this.noChangeParameters = Static.copyObjet(this.parameterList.filtros);
            this.noChangeParameters.forEach(item=>{
              item['disponible'] = true;
            })
          })
        }
        
      }else{
        this.template = this.primaryTpl;
        this.enableTable = false;
      }
    }
  }

  /**
   * Accion de retroceder en la vista
   *
   * @memberof FlowComponent
   */
   backInShearchFilter() {
    if (this.controls.length && !this.show.filterForm) {
      this.show.filterForm = true;
    } else {
      this.filterForm = null;
      this.controls = [];
      this.instances = [];
      this.formulario = this.fb.group({
        filtros: this.fb.array([]),
      });
      if(this.searchByProcess){
        this.selectedDefaultTramite();
        this.template = this.filtersTpl;
        this.fromDateSelector = "";
        this.toDateSelector = "";
      }else{
        this.template = this.primaryTpl;
      }
      this.selectedParameter.length = 0;
      this.searchFilters = false; 
    }
  }

  /**
   * Abre el modal de cancelacion de secundaria
   *
   * @memberof HeaderTitleTaskComponent
   */
  openModal() {
    this.modalRef = this.modalService.show(
      this.modalCancelSecondary,
      Object.assign({}, { class: "modal-lg", ignoreBackdropClick: true })
    );
  }

  /**
   * Controla la accion de cancelar una secundaria
   *
   * @param {*} data
   * @memberof FlowComponent
   */
  cancelSecondary(data: any) {
    log.debug("cancelar secundaria", data);
    this.confirmRef
      .new({
        question: "¿Esta seguro de cancelar el proceso secundario?",
        labelConfirm: "si",
        labelDecline: "no",
      })
      .then(async (res) => {
        if (res) {
          if (this.idTaskSecondary && this.idTaskSecondary > 0) {
            this.modalRef.hide();
            this.isLoading.cancelSecondary = true;
            this.fs
              .cancelSecondary(this.idTaskSecondary, data.txtMotivo)
              .then(() => {
                this.goBack();
                this.isLoading.cancelSecondary = false;
              })
              .catch((err) => {
                log.debug(err);
                this.goBack();
                this.isLoading.cancelSecondary = false;
              });
          }
        }
      });
  }

  /**
   * Se ejecuta cuando detecta una notificación con un
   * evento click de una tarea.
   * - Si la tarea es un microproceso genera su flujo.
   *
   * @private
   * @param {any} data
   * @param {string} action
   * @memberof FlowComponent
   */
  private clickedTask(data: any, action: string) {
    switch (action) {
      // Cuando se va abrir un formulario fuera de la modal
      case "openFormOutModal":
        this.backupDataSelectTramiteComponent();
        this.templateF = data.template;
        this.openForm = true;
        setTimeout(() => {
          this.sts.scrollTo({
            target: "headerFlow",
          } as ScrollToConfigOptions);
        });
        break;
      // Mostrar cargar del flujo para accion de finalizar tarea
      case "isLoadingFinishTask":
        this.isLoading.finishTask = true;
        this.openForm = false;
        this.templateF = null;
        break;
      case "isLoadingAssociationTramite":
        this.isLoading.associationTramite = !this.isLoading.associationTramite;
        this.openForm = false;
        this.templateF = null;
        break;
      case "closeLoadingFinishTask":
        this.isLoading.finishTask = false;
        break;
      // Cuando se va a finalizar la tarea
      case "finishTask":
        this.isLoading.finishTask = false;
        this.refreshInstance();
        break;
      // Cuando se va abrir un microproceso
      case "runMicroProcess":
        if (!isEmpty(data)) {
          this.runMicroProcess(data.task);
        }
        break;
      // Cuando se va abrir una secundaria
      case "runSecondary":
        this.typeProcess = "secondary_process";
        log.debug(data);
        if (!isEmpty(data)) {
          this.idTaskSecondary = data.task.id;
          this.runMicroProcess(data.task, false, false, false, true);
        }
        break;
      // Cuando se va a cerrar un formulario fuera de la modal
      case "closeTaskForm":
        /*         this.template = 'primary'; */
        this.openForm = false;
        this.templateF = null;
        break;
      // Cuando se necesita actualizar la informacion del flujo
      case "updateTask":
        const activityCurrent: Actividad = this.instance.actividades.find((element: Actividad) => {
          return element.id === data.meta.idActivity;
        });
        activityCurrent.tareas[data.meta.index] = data;
        break;
      // Cuando se necesita refrescar el flujo
      case "refreshFlow":
        this.refreshFlow();
        break;
      // Cuando se indica que se iniciaria un proceso secundario
      case "startSecondary":
        this.startSecondary(data);
        break;
      // Cuando se ejecuta el auto guardar en tareas
      case "autoSave":
        if (data && data.length) {
          this.contextAutoSave = data;
          this.finishTaskAutoSave();
        } else {
          if (this.isLoading.alertDynamic) {
            this.messageAlertDynamic = "";
            this.isLoading.alertDynamic = false;
          }
          if (!this.contextAutoSave && !this.contextAutoSave.length) {
            this.refreshFlow();
          }
        }
        break;
      // Cuando se desea mostrar la alerta de cargando con un mensaje dinamico
      case "alertLoadDynamic":
        if (data && typeof data === "string") {
          this.messageAlertDynamic = data;
          this.isLoading.alertDynamic = true;
          this.openForm = false;
          this.templateF = null;
        } else {
          this.messageAlertDynamic = "";
          this.isLoading.alertDynamic = false;
        }
        break;
    }
  }

  /**
   * Se encarga de iniciar un proceso secundario en el flujo
   *
   * @private
   * @param {DataIniciarSecundaria} data
   * @memberof FlowComponent
   */
  private startSecondary(data: DataIniciarSecundaria) {
    this.isLoading.startSecondary = true;
    const dataForm = {
      tarea: data.tarea_id,
    };
    this.fs
      .startSecondary(data.id, dataForm)
      .then(() => {
        this.isLoading.startSecondary = false;
        this.refreshFlow();
      })
      .catch((error) => {
        log.debug(error);
        this.isLoading.startSecondary = false;
        this.refreshFlow();
      });
  }

  /**
   * Consulta un microproceso y crea su flujo.
   *
   * @private
   * @param {(Tarea | number)} task
   * @param {boolean} [goBack=false]
   * @param {boolean} [clean=false]
   * @param {boolean} [changeCurrent=false]
   * @param {boolean} [secondary=false]
   * @memberof FlowComponent
   */
  private async runMicroProcess(
    task: Tarea | number,
    goBack: boolean = false,
    clean: boolean = false,
    changeCurrent: boolean = false,
    secondary: boolean = false
  ) {
    this.isLoading.showInstance = true;
    let idTask = typeof task === "number" ? task : task.id;
    if (typeof task === "number") {
      idTask = task;
    } else if (task && task.historial_microproceso) {
      let ordenMax = 0;
      task.historial_microproceso.forEach((history) => {
        if (history.orden > ordenMax) {
          ordenMax = history.orden;
          idTask = history.id;
        }
      });
    } else {
      idTask = task.id;
    }
    if (typeof task === "object") {
      if (!this.historysMicroproces[idTask]) {
        this.historysMicroproces[idTask] = task.id;
      }
      this.historyMicroproce = task.historial_microproceso;
    } else {
      if (this.historysMicroproces[idTask]) {
        this.historyMicroproce = await this.fs.getHistoryMicroproces(this.historysMicroproces[idTask]);
        if (this.historyMicroproce && this.historyMicroproce.length) {
          this.historyMicroproce.forEach((history) => {
            if (!this.historysMicroproces[history.id]) {
              this.historysMicroproces[history.id] = this.historysMicroproces[idTask];
            }
          });
        }
      }
    }
    if (this.historyMicroproce && this.historyMicroproce.length) {
      this.historyMicroproce.sort((a, b) => b.orden - a.orden);
    }
    this.idHistorySelect = idTask;
    log.debug("idhistory: ", this.idHistorySelect);
    this.fs
      .getMicroProcess(idTask)
      .finally(() => {
        this.isLoading.showInstance = false;
      })
      .subscribe((instance: Microproceso) => {
        if (secondary) {
          this.idSecondary = instance.id;
        }
        this.selectedInstance(instance, goBack, clean, changeCurrent);
      });
    this.template = "primary";
  }

  /**
   * Volver a consultar la instancia actual y mostrar su flujo.
   *
   * @private
   * @memberof FlowComponent
   */
  private refreshInstance() {
    this.hfs.reloadFlow(
      (currentInstance) => this.getInstance(currentInstance),
      (currentInstance) => this.runMicroProcess(currentInstance, false)
    );
  }

  /**
   * Consulta los tramites
   *
   * @private
   * @param {number} idTramite
   * @param {*} [filters]
   * @memberof FlowComponent
   */
  private shearchTramites(idTramite: number, filters?: any) {
    this.shearchFilter = filters ? true : false;
    this.fs.getInstanceDefaultTramites(idTramite, filters).subscribe((data) => {
      if (data.length) {
        data.sort((a, b) => a.id - b.id);
        this.instances = data;
      }
      this.loadDinamicFieldFromTable();
    });
  }

  /**
   * Genera las columns de los campos dinamicos en la tabla
   *
   * @private
   * @memberof FlowComponent
   */
  private loadDinamicFieldFromTable() {
    const configTable = new FlowConfig();
    this.settings = {};
    if (this.instances && this.instances.length) {
      if (this.instances[0].campos && this.instances[0].campos.length) {
        this.instances.forEach((cd) => {
          cd.campos.sort((a, b) => a.orden - b.orden);
        });
        this.instances[0].campos.forEach((field) => {
          configTable.generateColumn(field.orden + " ", field.nombre_parametro);
        });
      }
    }
    this.settings = configTable.settings;
    this.loadTableShearchTramite();
  }

  /**
   * Carga la informacion de cada tramite consultado en la tabla
   *
   * @private
   * @memberof FlowComponent
   */
  private loadTableShearchTramite() {
    this.source = [];
    if (this.instances && this.instances.length) {
      this.instances.forEach((instance) => {
        const d: DataSourceTramite = {
          id: instance.id,
          fechaCreacion: instance.expediente.fecha_creacion,
          idExpediente: instance.expediente.id,
          radicadoExpediente: instance.expediente.codigo,
          estadoNombre: instance.expediente.expediente_estado.nombre,
          estado: instance.expediente.expediente_estado,
          radicadoSolicitud: instance.expediente.radicado_solicitud,
        };
        if (instance.campos && instance.campos.length) {
          instance.campos.forEach((field) => {
            d[field.orden + " "] = field.valor;
            if (field["formato_fecha"]) {
              d["formato_fecha"] = field["formato_fecha"];
            }
          });
        }
        this.source.push(d);
      });
    }
    this.sourceData = new LocalDataSource(this.source);
    this.sourceData.refresh();
    this.isLoading.listInstances = false;
    this.show.filterForm = false;
  }

  /**
   * Carga la maestra seleccionada para un campo de filtros de tipo ngSeelect
   *
   * @private
   * @param {ParametroFiltro} field
   * @returns {Promise<any>}
   * @memberof FlowComponent
   */
  private async loadingSelectsOptions(field: ParametroFiltro): Promise<any> {
    return new Promise(async (resolve) => {
      const columnsMaster: Array<Option> = [];
      if (field.tipo_campo["nombre"] === "ngSelect") {
        let specificEstructure: EstructuraEspecifica;
        let columns: ValoresEspecificos[] = [];

        specificEstructure = this.loadingColumnsStructureMaster(
          field.campo["maestra"]["id"],
          field.campo["maestra"]["columnas_seleccionadas"]
        );

        columns = await this.fs.getColumnsSpecificMasterTable(specificEstructure);
        if (columns.length) {
          columns.forEach((column) => {
            let labelSelect = "";

            field.campo["maestra"]["columnas_seleccionadas"].forEach((col: number, index: any) => {
              if (index > 0) {
                labelSelect += " / ";
              }
              if (column.valores[col]) {
                labelSelect += column.valores[col];
              } else {
                labelSelect += "No aplica";
              }
            });
            columnsMaster.push({ value: column.id, key: labelSelect });
          });
        }
      }
      field["options"] = columnsMaster;
      resolve(true);
    });
  }

  /**
   * Ejecuta un for de forma sincronica
   *
   * @private
   * @param {Array<any>} array
   * @param {*} callback
   * @memberof FlowComponent
   */
  private async asyncForEach(array: Array<any>, callback: any) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
      continue;
    }
  }

  /**
   * Genera la estructura de consulta de la maestra con las columnas seleccionadas
   *
   * @private
   * @param {string} idMaster
   * @param {Array<any>} columns
   * @returns {EstructuraEspecifica}
   * @memberof FlowComponent
   */
  private loadingColumnsStructureMaster(idMaster: string, columns: Array<any>): EstructuraEspecifica {
    const colsDependence = {};
    const specificStructure: EstructuraEspecifica = {
      maestra: String(idMaster),
      columnas: [],
      dependencia: [],
    };
    columns.forEach((col: string, index: number) => {
      const cols = col.split("_");
      const column = Number(cols[0]);
      if (cols.length === 1) {
        specificStructure.columnas.push(column + " ");
      } else if (cols.length !== 0) {
        cols.splice(0, 1);
        col = "";
        cols.forEach((c, i) => {
          col += c;
          if (i < cols.length - 1) {
            col += "_";
          }
        });
        if (colsDependence[column]) {
          colsDependence[column].push(col);
        } else {
          colsDependence[column] = [col];
        }
      }
    });
    if (Object.keys(colsDependence).length) {
      Object.keys(colsDependence).forEach((key) => {
        specificStructure.dependencia.push(this.loadingColumnsStructureMaster(key + " ", colsDependence[key]));
      });
    }
    return specificStructure;
  }

  /**
   * Prepara la tarea a ejecutar el auto guardado
   *
   * @private
   * @param {ContextAutoSave} data
   * @memberof FlowComponent
   */
  private finishAutoSave(data: ContextAutoSave) {
    if (this.messageAlertDynamic !== data.messageLoad) {
      this.messageAlertDynamic = data.messageLoad;
    }
    if (!this.isLoading.alertDynamic) {
      this.isLoading.alertDynamic = true;
    }
    if (this.componentFormAutoSave) {
      this.componentFormAutoSave.clear();
    }
    if (data.task.tarea_tipo.nombre === Const.TYPES_TASK.form) {
      const factory = this.cfr.resolveComponentFactory(DynamicContentFormComponent);
      this.componentRef = this.componentFormAutoSave.createComponent(factory);
      this.componentRef.instance.task = data.task;
      this.componentRef.instance.context = {
        task: data.task,
        typeProcess: data.typeProcess,
      };
      this.componentRef.instance.autoSave = true;
      this.componentRef.instance.event.subscribe((event: any) => this.manageEvent(event));
    } else if (data.task.tarea_tipo.nombre === Const.TYPES_TASK.none) {
      const dataEvent: ConfigFinishDefault = {
        tarea: data.task.id,
      };
      dataEvent["task"] = data.task;
      this.manageEvent({
        type: "finishAutoSave",
        data: dataEvent,
      });
    } else {
      this.finishTaskAutoSave();
    }
  }

  /**
   * Controla los eventos notificados por el componente de renderizacion de formulario dinamico
   * para la tarea actual ejecutando auto guardado
   *
   * @param {TaskEvent} e
   * @memberof FlowComponent
   */
  manageEvent(e: TaskEvent) {
    let skipFinish = false;
    if (e.hasOwnProperty("params")) {
      skipFinish = e.params.hasOwnProperty("skip") ? e.params.skip : false;
    }
    switch (e.type) {
      case "finishAutoSave":
        this.componentFormAutoSave.clear();
        this.finish(e.data, skipFinish);
        break;
    }
  }

  /**
   * Ejecuta la finalizacion de la tarea
   *
   * @param {*} data
   * @param {boolean} [_skip=false]
   * @memberof FlowComponent
   */
  async finish(data: any, _skip: boolean = false) {
    // Inicio finalizacion tarea
    let isFinished: boolean;
    let autoSaved = false;
    const taskFinish: Tarea = data.task;
    switch (taskFinish.tarea_tipo.nombre) {
      // Ninguna, condición y forma especifica
      case Const.TYPES_TASK.none:
      case Const.TYPES_TASK.condition:
      case Const.TYPES_TASK.form:
        if (data["id_opciones"] && data["id_opciones"].length) {
          let f = true;
          isFinished = true;
          await this.asyncForEach(data["id_opciones"], async (el: number) => {
            const d: ConfigFinishDefault = {
              tarea: data["tarea"],
              id_opcion: el,
            };
            f = await this.ts.finishDefault(d);
            if (!f) {
              isFinished = false;
            }
          });
        } else {
          isFinished = await this.ts.finishDefault(data as ConfigFinishDefault);
        }
        break;
    }
    if (isFinished) {
      let automaticEndings: TareaFinalizacion[];
      if (data["id_opciones"] && data["id_opciones"].length) {
        automaticEndings = filter(
          taskFinish.tarea_finalizacion,
          (f) => data["id_opciones"].indexOf(f.opcion) && f.parametros["auto_guardado"] && f.tarea_destino
        );
      } else {
        automaticEndings = filter(
          taskFinish.tarea_finalizacion,
          (f) => f.parametros["auto_guardado"] && f.tarea_destino
        );
      }
      // Auto guardado de tareas
      if (automaticEndings.length) {
        autoSaved = true;
        await Static.asyncForEach(automaticEndings, async (endings) => {
          if (endings.tarea_destino) {
            const task = await this.ts.getInstanceTask(endings.tarea_destino);
            // Obtener el formulario para renderizar la tarea
            let formType = null;
            const name =
              task.tarea_tipo.nombre === Const.TYPES_TASK.form
                ? task
                  ? task.tarea_forma
                    ? task.tarea_forma.length
                      ? task.tarea_forma[0].nombre
                      : undefined
                    : undefined
                  : undefined
                : undefined;
            if (task.tarea_tipo.nombre !== Const.TYPES_TASK.microProcess) {
              const forma: Array<any> = new Array(task.tarea_forma);
              if (forma[0].length > 0) {
                formType = this.hfs.getFormType(task.tarea_tipo.nombre, name, task.tarea_forma[0].forma_especifica);
              } else {
                formType = this.hfs.getFormType(task.tarea_tipo.nombre, name, true);
              }
            }
            task.meta = {
              idActivity: task["tarea_actividad"]["id"] ? task["tarea_actividad"]["id"] : null,
              formType: formType,
            };
            this.contextAutoSave.push({
              idTaskOrigin: endings.tarea_inicio,
              task: task,
              typeProcess: this.typeProcess,
              messageLoad: endings.parametros["auto_guardado"],
            });
          }
        });
      }
      this.finishTaskAutoSave();
    } else {
      this.messageAlertDynamic = "";
      this.isLoading.alertDynamic = false;
    }
  }

  /**
   * Ejecuta la finalizacion automatica de una tarea en cola
   *
   * @private
   * @memberof FlowComponent
   */
  private finishTaskAutoSave() {
    if (this.contextAutoSave && this.contextAutoSave.length) {
      const dataAutoSave = Static.copyObjet(this.contextAutoSave[0]);
      this.contextAutoSave.splice(0, 1);
      this.finishAutoSave(dataAutoSave);
    } else {
      this.messageAlertDynamic = "";
      this.isLoading.alertDynamic = false;
      this.refreshFlow();
    }
  }

  /**
   *Método en el cual se crean los formularios para filtros
   *
   * @memberof FlowComponent
   */
  crearFormulario() {
    this.formulario = this.fb.group({
      filtros: this.fb.array([]),
    });
    const newform = this.createForm();
    const myFormArray = <FormArray>this.formulario.get("filtros");
    newform.get("groupIndex").patchValue(myFormArray.length);
    this.filtros.push(newform);
  }

  /**
   *Obtiene los formularios de los filtros
   *
   * @readonly
   * @type {FormArray}
   * @memberof FlowComponent
   */
  get filtros(): FormArray {
    return this.formulario ? this.formulario.get("filtros") ? this.formulario.get("filtros") as FormArray : null : null;
  }

  /**
   *Añade un formulario de filtro
   *
   * @memberof FlowComponent
   */
  addFilter() {
    if(!this.formulario){
      this.searchFilters = true;
      this.crearFormulario();
    }else{
      let valid: boolean = true;
      this.filtros.value.forEach((filter: any) => {
        if ((filter.filtro === "" && filter.tipo_filtro !== 'rango_fechas' && filter.tipo_filtro !== 'en_lista') || filter.selector === undefined || filter.selector === null) {
          valid = false;
        }
        if((filter.tipo_filtro == 'rango_fechas' && this.toDateSelector == '' && this.fromDateSelector == '')){
          valid = false;
        }
        if((filter.tipo_filtro == 'en_lista' && this.selectedListItem == null)){
          valid = false;
        }
      });
      if (!valid) {
        this.toastr.warning("Debe llenar todos los campos", "Error en la acción");
      } else {
        if(this.unselectedParameters.length){
          const newform = this.createForm();
          const myFormArray = <FormArray>this.formulario.get("filtros");
          newform.get("groupIndex").patchValue(myFormArray.length);
          this.filtros.push(newform);
        }else{
          this.toastr.warning("No hay más parámetros de búsqueda", "Error en la acción");
        }
      }
    }
  }

  /**
   *Elimina un formulario de filtro
   *
   * @param {number} indice
   * @memberof FlowComponent
   */
  deleteFilter(indice: number) {
    if(this.filtros.value[indice].selector !== undefined){
      if(this.filtros.value[indice].tipo_filtro == 'rango_fechas'){
        this.fromDateSelector = '';
        this.toDateSelector = '';
      }
      if(this.filtros.value[indice].tipo_filtro == 'en_lista'){
        this.selectedListItem = null;
      }
      if(this.selectedParameter.length){
        let index = 0;
        let exist = false;
        this.selectedParameter.forEach((sp, i)=>{
          if(sp['index']==indice){
            index = i;
            exist = true;
          }
        })
        if(exist){
          this.selectedParameter.splice(index, 1);
          if(this.selectedParameter.length){
            this.selectedParameter.forEach(slctp=>{
              if(slctp['index'] >= indice){
                slctp.index = slctp.index - 1; 
              }
            });
          }
        }
        this.unselectedParameters.length = 0;
        this.unselectedParameters = [...this.unselectedParameters];
        let enable: boolean;
        this.noChangeParameters.forEach(ncp=>{
          enable = true;
          this.selectedParameter.forEach(sp=>{
            if(sp.id == ncp.id){
              enable = false
            }
          })
          if(enable){
            this.unselectedParameters = [...this.unselectedParameters, ncp]
          }
        })
      }
    }
    if(this.dataTableModal[indice]){
      delete this.dataTableModal[indice];
    }
    if(this.columnsSelect[indice]){
      delete this.columnsSelect[indice];
    }
    if(this.form[indice]){
      delete this.form[indice];
    }
    this.filtros.removeAt(indice);
  }

  async search() {
    this.selectedRange = '';
    if(this.searchByProcess){
      let vacio = false;
      if(this.selectedParameter && this.selectedParameter.length){
        if(this.filtros && this.filtros.length){
          this.filtros.value.forEach((element: any) => {
            if(element.selector == undefined || (element.filtro == '' && element.tipo_filtro !== 'rango_fechas' && element.tipo_filtro !== 'en_lista') || (element.tipo_filtro == 'rango_fechas' && (this.toDateSelector == '' && this.fromDateSelector== '')) || (element.tipo_filtro == 'en_lista' && this.selectedListItem == null)){
              vacio = true
            }
          });
        }
        
      }
      if((!this.selectedParameter.length && this.formulario && this.filtros.controls.length) || vacio){
        this.toastr.warning('Los filtros no deben estar incompletos', 'Error en la acción');
      }else{
        let valid = false;
        if(this.toDateSelector !== '' && this.fromDateSelector !== ''){
          if(this.toDateSelector < this.fromDateSelector){
            this.toastr.warning('La fecha final no debe ser menor que la fecha inicial', 'Error en la acción');
          }else{
            valid = true;
          }
        }else{
          valid = true
        }
        if(valid){
          this.isLoading.listInstances = true;
          this.structureProcess.sort(function (a, b) {
            if (a.orden > b.orden) {
              return 1;
            }
            if (a.orden < b.orden) {
              return -1;
            }
            return 0;
          });
          const configTable = new FlowConfig(this.structureProcess, this.parameterList);
          this.settings = configTable.settingsProcess;
          configTable.accion.subscribe((res: any) => {
            switch (res.action) {
              case "descargar":
                this.downloadingDocument = true;
                if(res.type_document == 'documento'){
                  let id_doc = res.id_documento ? res.id_documento : (res.data && res.data.id_documento) ? res.data.id_documento : null;
                  this.download(res.type_document, id_doc)
                }else{
                  let id_anexo = res.id_anexo ? res.id_anexo : (res.data && res.data.id_anexo) ? res.data.id_anexo : null;
                  this.download(res.type_document, id_anexo)
                }
                
                break;
              case "preview_documento":
                  this.previewDocument = true;
                  let id_doc_preview = res.id_documento_preview ? res.id_documento_preview : (res.data && res.data.id_documento_preview) ? res.data.id_documento_preview : null;
                  this.preview(id_doc_preview)
                  break;
              case "ver_flujo":
                this.getInstance(res.data.id);
                break;    
              default:
                break;
            }
          });
          this.show.filterForm = true;
          this.enableTable = true;
          const filtros: any[] = [];
          if(this.filtros){
            this.parameterList.filtros.forEach(pl=>{
              this.filtros.value.forEach((f: any) => {
                if(f.selector == pl.id && pl.tipo_estructura.nombre !== 'selector' &&  pl.tipo_estructura.nombre !== 'rango_fechas'){
                  let val = {};
                  val['id'] = pl.id;
                  val['alias'] = pl.alias;
                  val['valor'] = f.filtro;
                  filtros.push(val);
                }else if(f.selector == pl.id && pl.tipo_estructura.nombre == 'selector'){
                  let val = {};
                  val['id'] = pl.id;
                  val['alias'] = pl.alias;
                  val['valor'] = f.filtro.id;
                  filtros.push(val);
                }else if(f.selector == pl.id && pl.tipo_estructura.nombre == 'rango_fechas'){
                  let val = {};
                  val['id'] = pl.id;
                  val['alias'] = pl.alias;
                  val['valor'] = {};
                  val['valor']['fecha_inicial'] = this.datePipe.transform(this.fromDateSelector, 'yyyy-MM-dd');
                  val['valor']['fecha_final'] = this.datePipe.transform(this.toDateSelector, 'yyyy-MM-dd');
                  filtros.push(val);
                }
              });
            })
          }
          this.fs.getDynamicProcedureData(this.process_id, this.procedure_id, filtros).subscribe(res=>{
            if(res && res.length){
              if(this.colorConfiguration && this.colorConfiguration.tipo){
                res.forEach((r, i)=>{
                  if(r && r.color){
                    let config = {};
                    config['color'] = {};
                    config['color']['rango'] = this.colorConfiguration.rango_colores;
                    config['color']['valor'] = r.color;
                    config['color']['indice'] = i;
                    config['color']['datos'] = r;
                    // r['color']['rango'] = r.color;
                    r['color'] = config;
                  }
                })
              }
              this.sourceData = new LocalDataSource(res);
              this.color = "black";
            }else{
              let data: any[] = [];
              this.sourceData = new LocalDataSource(data);
              this.sourceData.refresh();
            }
            this.isLoading.listInstances = false;
          }, ()=>{
            this.isLoading.listInstances = false;
          })
        }
      }
    }else{
      if (this.history.tramite && this.history.tramite.id) {
        this.isLoading.listInstances = true;
        this.instances = [];
        this.controls = [];
        this.filters = await this.fs.getFiltersShearchTramite(this.history.tramite.id);
        if (!this.filters || !this.filters.parametros || !this.filters.parametros.length) {
          this.shearchTramites(this.history.tramite.id);
        } else {
  
          if (this.filters.parametros.length) {
            await this.asyncForEach(this.filters.parametros, async (parameter: ParametroFiltro) => {
              if (parameter.campo['maestra'] && parameter.tipo_campo.nombre === 'ngSelect') {
                await this.loadingSelectsOptions(parameter);
              }
            });
          }
          this.controls = this.ffs.getFieldsFilterReportStructure(this.filters.parametros, this.templates);
          this.isLoading.listInstances = false;
          this.show.filterForm = true;
        }
        // this.backupDataSelectTramiteComponent();
        this.template = 'instances';
        this.selectedParameter.length = 0;
      } else {
        this.toastr.warning('Seleccione un tramite.', 'Información incompleta');
      }
    }
  }


  /**
   *Retorna un formulario con la estructura necesaria de los filtros
   *
   * @return {*}
   * @memberof FlowComponent
   */
  createForm() {
    return this.fb.group({
      groupIndex: "",
      selector: "",
      filtro: new FormControl(''),
      minDate: "",
      maxDate: "",
      enable: false,
      tipo_filtro: "text",
      class: '',
      label_selector: []
    });
  }

  /**
   *Controla que las opciones de los selectores no se dupliquen
   *
   * @param {*} data
   * @param {number} index
   * @memberof FlowComponent
   */
  async onChangeState(data: any, index: number) {
    if (data !== undefined) {
      if(data.tipo_estructura.nombre == 'selector'){
        await this.fs.getList(data.sub_structura.nombre_servicio).then(async res=>{
          if(res){
            this.select_list = await res;
            if(this.dataTableModal){
              this.dataTableModal[index] = res;
            }
          }
        }, err=>{
          
        })
      }
      data['groupIndex'] = this.filtros.value[index].groupIndex;
      this.formulario.controls.filtros['controls'][index].patchValue({enable: true});
      this.filtros.value[index].tipo_filtro = data.tipo_estructura.nombre; 
      if(this.filtros.value[index].tipo_filtro == 'selector'){
        this.form[index] = new FormGroup({
          exampleModalSelect: new FormControl()
        });
        if(data && data.espacio && data.espacio < 9){
          this.filtros.value[index].class = 'container ml-0 mr-0 col-'+ data.espacio
        }else if(data && data.espacio){
          this.filtros.value[index].class = 'container ml-0 mt-1 mr-0 col-'+ data.espacio
        }
        this.columnsSelect[index] = data.sub_structura.estructura_modal
        this.filtros.value[index].label_selector = data.sub_structura.labels_selector; 
        this.columnsSelect[index].sort(function (a: { orden: number; }, b: { orden: number; }) {
          if (a.orden > b.orden) {
            return 1;
          }
          if (a.orden < b.orden) {
            return -1;
          }
          return 0;
        });
      }else if(this.filtros.value[index].tipo_filtro == 'texto'){
        if(data && data.espacio && data.espacio < 9){
          this.filtros.value[index].class = await 'form-control col-'+data.espacio
        }else if(data && data.espacio){
          this.filtros.value[index].class = await 'form-control mt-1 col-'+data.espacio
        }
      }else if(this.filtros.value[index].tipo_filtro == 'rango_fechas'){
        if(data && data.espacio && data.espacio < 9){
          this.filtros.value[index].class = await 'input-group mb-2 pd-0 col-'+data.espacio
        }else if(data && data.espacio){
          this.filtros.value[index].class = await 'input-group mb-2 mt-2 pd-0 col-'+data.espacio
        }
      }
      let item = data;
      let exist = false;
      let spIndex = 0;
      item['index'] = index;
      this.selectedParameter.forEach((sp, i)=>{
        if(sp['index']==item['index']){
          spIndex = i;
          exist = true
        }
      })
      if(exist){
        if(this.selectedParameter[spIndex].tipo_estructura.nombre == 'rango'){
          this.toDateSelector = '';
          this.fromDateSelector = '';
        }else if(this.selectedParameter[spIndex].tipo_estructura.nombre == 'modal'){
          this.filtros.value[index].filtro = null;
          this.form[index] = new FormGroup({
            exampleModalSelect: new FormControl()
          });
        }
        this.selectedParameter.splice(spIndex, 1, item);
      }else{
        this.selectedParameter.push(item);
      }

      this.unselectedParameters.length = 0;
      this.unselectedParameters = [...this.unselectedParameters];
      let enable: boolean;
      this.noChangeParameters.forEach(ncp=>{
        enable = true;
        this.selectedParameter.forEach(sp=>{
          if(sp.id == ncp.id){
            enable = false
          }
        })
        if(enable){
          this.unselectedParameters = [...this.unselectedParameters, ncp]
        }
      }) 
    }
  }

  changeSelection(data: any, filter: any, index:any){
    if(data !== null){
      let resultData = this.dataTableModal[index];
      if (resultData){
      resultData.forEach((d: { id: any; })=>{
        if(d.id == data.id){
          filter.value.filtro = data;
        }
      });
    }
    }
  }

  changeColumns(data: any){
    this.selectedParameter.forEach(async sp=>{
      if(sp['index'] == data){
        this.columnsSelect[data] = await sp.sub_structura.estructura_modal;
        // this.columnsSelect = await [...this.columnsSelect];
      }
    })
  }

  preview(document_id: number){
    if(document_id){
      this.fs.dowloadFile(document_id).subscribe((res: any) => {
        this.modalRef = this.modalService.show(this.templatePreviewDoc, { class:  'modal-personalized', initialState: res.file});
        let type = res.file.path.split(".").pop();
        let document = {"tipo": type, "ruta": res.file.path, "rutaGoogle": "https://docs.google.com/gview?url="+ res.file.path+"&embedded=true",
        "rutaMicrosoft":"https://view.officeapps.live.com/op/view.aspx?src="+res.file.path+"&wdOrigin=BROWSELINK"} 
        this.modalRef.content = document;
        this.previewDocument = false;
      }, err=>{
        this.previewDocument = false;
      });
    }
  }

  download(type_document: string, document_id: number){
    if(type_document == 'documento' && document_id){
      this.fs.dowloadFile(document_id).subscribe((res: any) => {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = res.file.path;
        a.download = res.file.name;
        a.click();
        a.remove();
        this.downloadingDocument = false;
      }, err=>{
        this.downloadingDocument = false;
      });
    }else if(type_document == 'documento_anexo' && document_id){
      this.fs.dowloadFileAnexed(document_id).subscribe((res: any) => {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = res.path;
        a.download = res.name;
        a.click();
        a.remove();
        this.downloadingDocument = false;
      }, err=>{
        this.downloadingDocument = false;
      });
    }
  }

  /**
   * 
   * @param data 
   * Controla los cambios en la tabla
   */
  onChangeTable(data: any){
    if (this.resApi && this.resApi.envio_servicio) {
      let selected = this.idsSelected.includes(data.data.id)
      if (selected) {
        for (let i = 0; i < this.idsSelected.length; i++) {
          if(this.idsSelected[i] == data.data.id && !!data.data.id )
          this.idsSelected.splice(i, 1)
        }
      } else {
        this.idsSelected.push(data.data.id);
      }
    } else {
      this.getInstance(data.data.id)
    }
  }
 
  /*
  Método para el envío de datos a la api
  */
  send(){
    if (this.resApi.multiple_seleccion == false && this.idsSelected.length > 1) {
      this.toastr.warning('Solo esta permitido seleccionar un trámite');
    } else {
      let dataSend: DataService;
      dataSend = {
        tipo: this.resApi.nombre_servicio,
        valores: this.idsSelected 
      }
      this.fs.sendDataService(dataSend).subscribe(res => {
        if (res) {
          this.toastr.success("Operación exitosa", 'Se han enviado los trámites correctamente');
          //Limpiar array de ids seleccionados
          this.idsSelected = [];
          this.search();
        }
      })
    }
  }

  /**
   * cierra el modal con el la previsualizacion de documento
   *
   * @memberof FlowComponent
   */
 closeModalPreviewDoc() {
  this.modalRef.hide();
}

} // End class



// WEBPACK FOOTER //
// ./src/app/flow/flow.component.ts